export class MultiSelectOptionApiModel {
    value: string;
    text: string;
    disabled: boolean;
}